import { render, staticRenderFns } from "./NotificationAvatar.vue?vue&type=template&id=6a95f9d0&scoped=true&"
import script from "./NotificationAvatar.vue?vue&type=script&lang=js&"
export * from "./NotificationAvatar.vue?vue&type=script&lang=js&"
import style0 from "./NotificationAvatar.vue?vue&type=style&index=0&id=6a95f9d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a95f9d0",
  null
  
)

export default component.exports